import React from 'react';
import styles from './customStatusLabel.module.scss';

export const CustomStatusLabel = (props) => {



    return (
        <div 
            className={`
                ${props.type === 'successStatus' ? styles.successStatus : ''}
                ${props.type === 'secondaryStatus' ? styles.secondaryStatus : ''}
                ${props.type === 'warningStatus' ? styles.warningStatus : ''}
                ${props.type === 'dangerStatus' ? styles.dangerStatus : ''}
            `}
        >
         <p className={styles.labelText}>{props.label}</p>        
        </div>
    )
}
